import { type Qualification } from "./types";

export function getQualificationLabel(name: string, qualifications: Qualification[]): string {
  return (
    qualifications.find((qualification) => qualification.attributes.name === name)?.attributes
      .displayLabel ?? name
  );
}
